var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPinterestIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.00006 19.9999L12.0001 10.9999",
    stroke: "#E60023",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6999 14.0001C11.1369 15.2631 12.1299 16.0001 13.2499 16.0001C15.3209 16.0001 16.9999 14.4461 16.9999 12.0001C17.0008 11.2699 16.8417 10.5484 16.5339 9.88627C16.226 9.22416 15.7769 8.6375 15.2181 8.16753C14.6593 7.69757 14.0043 7.3557 13.2992 7.16596C12.5941 6.97622 11.856 6.94322 11.1368 7.06927C10.4176 7.19531 9.73471 7.47735 9.13617 7.89557C8.53762 8.31378 8.03794 8.85801 7.67224 9.49001C7.30654 10.122 7.0837 10.8264 7.01938 11.5538C6.95506 12.2811 7.05082 13.0137 7.29994 13.7001",
    stroke: "#E60023",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9999 21C16.9705 21 20.9999 16.9706 20.9999 12C20.9999 7.02944 16.9705 3 11.9999 3C7.02938 3 2.99994 7.02944 2.99994 12C2.99994 16.9706 7.02938 21 11.9999 21Z",
    stroke: "#E60023",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinterestIcon);
export default __webpack_public_path__ + "static/media/pinterest-icon.4bd0a1d4.svg";
export { ForwardRef as ReactComponent };